import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ButtonHeading } from 'components'
import { AddEditLrModal, AddIndentModal, AddItemGroupModal, AddItemModal, AddLrModal, AddNewSeriesModal, EbillExtentionModal, EwayBillNewDetailsModal, FetchEwayBillLrModal, LrDetailModal, LrSeriesModal, PermissionModal, YoutubeModal } from 'modals'
import { getLrCountData, getMainLrListData, updateUserLrColumns, getLRDeaultColumn, deleteLrListData } from '_services/accountsServices/lrServices'
import StorageService from 'utils/StorageServices/StorageServices'
import { CustomTableNew } from 'components/CustomTable'
import moment from 'moment';
import AddEditConsignor from 'modals/AddEditConsignor/AddEditConsignor'
import { UserContext } from 'context'
import { updateInputValue } from 'features/lrFilterServices/lrFilterSlice';
import { useDispatch, useSelector } from 'react-redux'
import { updateSearchValue } from 'features/lrFilterServices/lrSearchSlice'
import useDocumentTitle from 'hooks/useDocumentTitle'
import { useNavigate, useParams } from 'react-router-dom'
import { actionPermission, ActionPermission, utils } from 'helper'
import { constant } from 'constants';
import { LR_PAR_PAGE_LIST } from 'lib/app-config'
import toast from 'react-hot-toast'

const Lr = ({ hideHeaderSection = true, detailsData = {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { id } = useParams();
  const { masterData, setIsMaterialIndex, lrPermissions, setLrDetialsFrom, lrModalToggleForEway, setLrModalToggleForEway, setEwayBillLrData, allMenu, permissionModal, setPermissionModal } = useContext(UserContext)
  const [show, setShow] = useState(false)
  const [showAddLR, setShowAddLR] = useState(false)
  const [showLrDetail, setShowLrDetail] = useState(false)
  const [showAddItem, setShowAddItem] = useState(false)
  const [showAddGroupItem, setShowAddGroupItem] = useState(false)
  const [isAddConsignor, setIsAddConsignor] = useState(false);
  const [dataLrCount, setDataLrCount] = useState('');
  const getFiltersValues = useSelector((state) => state.lrFilter)?.filters; // lr_pagination
  const getSearchValue = useSelector((state) => state.lrSearch);

  const [showAddIndent, setShowAddIndent] = useState(false);
  const [indentId, setIndentId] = useState("");

  // Lr table start 

  const [columns, setColumns] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [filterableColumns, setFilterableColumns] = useState([]);
  const [isMasterFilter, setIsMasterFilter] = useState(true);
  const [error, setError] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pageLimit, setPageLimit] = useState(LR_PAR_PAGE_LIST);
  const [totalPages, setTotalPages] = useState(1);
  const [activeStatus, setActiveStatus] = useState(getFiltersValues?.lr_status);
  const [showPrefield, setShowingPrefield] = useState(false);
  const [totalRecords, setTotalRecords] = useState('');

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    messageType: null,
    templateId: null,
    templateData: {}
  });

  useDocumentTitle("LR | T360");

  const childsUser = useMemo(() =>
    allMenu?.find((i) => i?.label === 'Trip'),
    [allMenu]
  );

  const getLrDataList = async (consignorId) => {
    setLoading(true);
    try {
      let postData = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        branch_id: getFiltersValues?.branch_id?.value ? getFiltersValues?.branch_id?.value : '',
        consignor_id: hideHeaderSection ? (getFiltersValues?.consignor_id?.value ? getFiltersValues?.consignor_id?.value : '') : (consignorId ? consignorId : detailsData?._id), // getFiltersValues?.consignor_id?.value ? getFiltersValues?.consignor_id?.value : '',
        start_date: getFiltersValues?.start_date ? moment(getFiltersValues?.start_date)?.format("YYYY-MM-DD") : '',
        end_date: getFiltersValues?.end_date ? moment(getFiltersValues?.end_date)?.format("YYYY-MM-DD") : '',
        // start_date: getFiltersValues?.start_date ? moment(getFiltersValues?.start_date) : '',
        // end_date: getFiltersValues?.end_date ? moment(getFiltersValues?.end_date) : '',
        search: getSearchValue?.search ? getSearchValue?.search : '',
        from_location: getFiltersValues?.from_location?.value ? getFiltersValues?.from_location?.value : '',
        to_location: getFiltersValues?.to_location?.value ? getFiltersValues?.to_location?.value : '',
        pod_status: getFiltersValues?.pod_status?.value ? getFiltersValues?.pod_status?.value : 0,
        eway_bill_status: getFiltersValues?.eway_bill_status?.value ? getFiltersValues?.eway_bill_status?.value : 0,
        lr_status: getFiltersValues?.lr_status,
        limit: pageLimit,
        offset: getSearchValue?.search != '' ? 1 : getFiltersValues?.lr_pagination,
        select_lr_ids: []
      }
      const response = await getMainLrListData(postData);
      setColumns(response?.data?.lr_columns);
      setApiData(transformData(response?.data?.lr_list));
      setFilterableColumns(response?.data?.lr_filter_columns);
      setIsMasterFilter(true);
      setTotalPages(Math.ceil(response?.data?.total_record / pageLimit));
      setTotalRecords(response?.data?.total_record)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  const getLrTopStatusCount = async (consignorId) => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        branch_id: getFiltersValues?.branch_id?.value ? getFiltersValues?.branch_id?.value : '',
        consignor_id: hideHeaderSection ? (getFiltersValues?.consignor_id?.value ? getFiltersValues?.consignor_id?.value : '') : (consignorId ? consignorId : detailsData?._id),
        start_date: getFiltersValues?.start_date ? moment(getFiltersValues?.start_date)?.format("YYYY-MM-DD") : '',
        end_date: getFiltersValues?.end_date ? moment(getFiltersValues?.end_date)?.format("YYYY-MM-DD") : '',
        // start_date: getFiltersValues?.start_date ? moment(getFiltersValues?.start_date) : '',
        // end_date: getFiltersValues?.end_date ? moment(getFiltersValues?.end_date) : '',
        search: getSearchValue?.search ? getSearchValue?.search : '',
        from_location: getFiltersValues?.from_location?.value ? getFiltersValues?.from_location?.value : '',
        to_location: getFiltersValues?.to_location?.value ? getFiltersValues?.to_location?.value : '',
        eway_bill_status: getFiltersValues?.eway_bill_status?.value ? getFiltersValues?.eway_bill_status?.value : 0,
        pod_status: getFiltersValues?.pod_status?.value ? getFiltersValues?.pod_status?.value : 0,
        // lr_status: lrStatus,
        // limit: pageLimit,
        // offset: getFiltersValues?.lr_pagination,
      }
      const res = await getLrCountData(object);
      if (res?.responseCode == 200) {
        setDataLrCount(res?.data?.lr_status)
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    getLrDataList(id);
  }, [getFiltersValues, getSearchValue?.search, masterData, id])

  useEffect(() => {
    getLrTopStatusCount(id);
  }, [id, getSearchValue?.search, getFiltersValues?.branch_id?.value, getFiltersValues?.consignor_id?.value, getFiltersValues?.end_date, getFiltersValues?.start_date, getFiltersValues?.eway_bill_status, getFiltersValues?.from_location?.value, getFiltersValues?.to_location?.value, getFiltersValues?.pod_status])

  // useEffect(() => { 
  //   //getSearchValue?.search != '' && 
  //   if (getSearchValue?.search !== undefined) {
  //     const delayDebounceFn = setTimeout(() => {
  //       getLrDataList();
  //       getLrTopStatusCount();
  //     }, 500);

  //     return () => clearTimeout(delayDebounceFn);
  //   }
  // }, [getSearchValue?.search]);

  // useEffect(() => {
  //   if (getFiltersValues?.lr_status) {
  //     setActiveStatus(getFiltersValues?.lr_status);
  //   }
  // }, [getFiltersValues?.lr_status])

  const paginationFunction = (value) => {
    const stateObj = { ...getFiltersValues, lr_pagination: value };
    dispatch(updateInputValue(stateObj))
  }

  const updateGlobalFilters = (value) => {
    const stateObj = { ...getFiltersValues, lr_status: value, lr_pagination: 1 };
    dispatch(updateInputValue(stateObj))
  }

  const handleDetailsAction = (data) => {
    setShowLrDetail(data);
  }

  const handleEditIndent = (id) => {
    setIndentId(id);
    setShowAddIndent(true);
  };


  const handlePermissionCallTrip = async (link) => {
    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.TRIP,
      onSuccess: () => navigate(link),
      setModalConfig
    });
  };

  const transformData = (data) => {
    return data.map(item => ({
      lr_number: item?.lr_number ? <div className='_tblText _lrNums __inLineNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> {item?.lr_number} </a> </div> : <div className='_tblText _lrNums __inLineNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> View </a> </div>,
      plan_id: item?.plan_id?.indent_number ? <div className='_tblText'>{item?.plan_id?.indent_number} </div> : '-',
      invoice_date: item?.invoice_date ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.invoice_date).format('DD MMM YYYY')}</span>
        <span className='_lgtText'>{moment(item?.invoice_date).format('hh:mm A')}</span>
      </div> : '-',
      dispatch_date: item?.trip_id?.dispatch_date ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.trip_id?.dispatch_date).format('DD MMM YYYY')}</span>
        <span className='_lgtText'>{moment(item?.trip_id?.dispatch_date).format('hh:mm A')}</span>
      </div> : '-',
      consignor_name: item?.consignor_id?.name ? <div className='_tblText _oneLine_tx'>{item?.consignor_id?.name}</div> : '-',
      branch_name: item?.branch_id?.branch ? <div className='_tblText _oneLine_tx'>{item?.branch_id.branch}</div> : '-',
      // from_location: item?.from_location ? item?.from_location : '-',
      from_location: item?.from_location ? (
        <div className='_locationWid_bx' onClick={(e) => handleDetailsAction(item)}>
          <p className="_tblText">{item.from_location}</p>
          {((item.unit_id && item.unit_id.code) || (item.unit_id && item.unit_id.name)) && <p className="_lgtText">{item.unit_id && item.unit_id.code && item.unit_id.code} | {item.unit_id && item.unit_id.name && item.unit_id.name} </p>}
        </div>
      ) : '-',
      // to_location: item?.to_location ? item?.to_location : '-',
      to_location: item?.to_location ? (
        <div className='_locationWid_bx'>
          <p className="_tblText">{item.to_location}</p>
          {((item.consignee_id && item.consignee_id.code) || (item.consignee_id && item.consignee_id.name)) && <p className="_lgtText">{item.consignee_id && item.consignee_id.code && item.consignee_id.code} | {item.consignee_id && item.consignee_id.name && item.consignee_id.name} </p>}
        </div>
      ) : '-',
      // lr_status: item?.lr_status ? item?.lr_status : '-',
      lr_status: item?.lr_status ? (
        // <span className="bg-success"> {item.lr_status} </span>
        <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span>
      ) : '-',
      pod_status: item?.pod_status ? <span className={masterData?.pod_status[item?.pod_status] === 'Pending' ? '_lrPending_status' : (masterData?.pod_status[item?.pod_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.pod_status[item?.pod_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.pod_status[item?.pod_status] === 'Received' ? '_lrDelivered_status' : (masterData?.pod_status[item?.pod_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.pod_status[item?.pod_status] ? masterData?.pod_status[item?.pod_status] : ''} </span>
        : '-',
      created_by: item?.created_by ? <div className='_tblText'>{item?.created_by}</div> : '-',
      eway_bill_number: item?.eway_bill_number ? <div className='_tblText'>{item?.eway_bill_number}</div> : '-',
      eway_bill_date: item?.eway_bill_date ? <div className='_dateNtime'>
        <span className='_tblText'>{utils.formatUTCDateNative(item?.eway_bill_date)}</span>
        <span className='_lgtText'>{moment(item?.eway_bill_date).format('hh:mm A')}</span>
      </div> : '-',
      eway_expiry_date: item?.eway_expiry_date ? <div className='_dateNtime'>
        <span className='_tblText'>{utils.formatUTCDateNative(item?.eway_expiry_date)}</span>
        <span className='_lgtText'> 11:59 PM </span>
      </div> : '-', // {moment(item?.eway_expiry_date).format('hh:mm A')}
      eway_bill_status: item?.eway_bill_status ?
        <span className={masterData?.eway_bill_status[item?.eway_bill_status] === 'Without Eway' ? '_lrPending_status' : (masterData?.eway_bill_status[item?.eway_bill_status] === 'Active Eway' ? '_lrInTransit_status' : (masterData?.eway_bill_status[item?.eway_bill_status] === 'Expiring Today' ? '_lrPartyPoint_status' : ((masterData?.eway_bill_status[item?.eway_bill_status] === 'Closed' ? '_lrDelivered_status' : '_lrPartyPoint_status'))))}> {masterData?.eway_bill_status[item?.eway_bill_status] ? masterData?.eway_bill_status[item?.eway_bill_status] : ''} </span>
        //  <div className='_tblText'>{masterData?.eway_bill_status[item?.eway_bill_status]}</div> 
        : '-',
      total_qty: item?.total_qty ? <div className='_tblText'>{item?.total_qty}</div> : '-',
      total_kot: item?.total_kot ? <div className='_tblText'>{item?.total_kot}</div> : '-',
      total_freight: item?.total_freight ? <div className='_tblText' style={{whiteSpace:'nowrap'}}>&#x20B9; {item?.total_freight}</div> : '-',
      dispatch_date: item?.dispatch_date ? <div className='_tblText'>{moment(item?.dispatch_date).format('DD MMM YYYY')}</div> : '-',
      at_party_point_date: (item?.lr_process?.length > 0 && item?.lr_process?.find((el) => el?.type === 'party_point')?.date) ? <div className='_tblText'>{moment(item?.lr_process?.find((el) => el?.type === 'party_point')?.date).format('DD MMM YYYY')}</div> : '-',
      // eway_bill_status: item?.eway_bill_status === 0 ? <span className='_lrPending_status'>  Pending </span> : '-',
      vehicle_no: item?.vehicle_no ? <div className='_tblText'>{item?.vehicle_no}</div> : '-',
      vehicle_ownership: item?.vehicle_ownership ? <div className='_tblText'>{masterData?.vehicle_ownership[item?.vehicle_ownership]}</div> : '-',
      lorry_type: item?.lorry_type ? <div className='_tblText'>{item?.lorry_type}</div> : '-',
      supplier_name: item?.supplier_name ? <div className='_tblText'>{item?.supplier_name}</div> : '-',
      vehicle_type: item?.vehicle_type ? <div className='_tblText'>{item?.vehicle_type}</div> : '-',
      indent_number: item?.indent_number ? <div className='_tblText _lrNums __inLineNums' onClick={(e) => handleEditIndent(item?.plan_id?._id)}> <a className='_avPointer'> {item?.indent_number} </a> </div> : '-',
      pod_date: item?.pod_date ? <div className='_tblText'>{moment(item?.pod_date).format('DD MMM YYYY')}</div> : '-',
      pod_file: item?.pod_file ? <div className='_tblText'>{item?.pod_file?.length ? item?.pod_file?.length : 0}</div> : '-',
      trip_number: item?.trip_number ? <div className='_tblText _lrNums __inLineNums' onClick={(e) => navigate(`/trip/addtrip/dispatched/${item?.trip_id?._id}`)}>
        <a className='_avPointer'>{item?.trip_number} </a> </div>
        : (childsUser?.create === 1 ? <div className='_tblText _lrNums __inLineNums' onClick={() => { setLrDetialsFrom(item); handlePermissionCallTrip('/trip/addtrip/createtrip2'); }}>
          <a className='_avPointer'> Create Trip </a>
        </div> : <div className='_tblText _lrNums __inLineNums' onClick={() => setPermissionModal(true)}>
          <a className='_avPointer'> Create Trip </a>
        </div>),
      driver_name: item?.driver_name ? <div className='_tblText'>{item?.driver_name}</div> : '-',
      delivery_date: item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date ? moment(item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date).format('DD MMM YYYY') : '',
      delivery_time: item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date ? moment(item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date).format('hh:mm A') : '',
      total_weight: item?.total_weight ?
        <div className='_tblText'>{item?.total_weight} kg </div>
        : '-',
      invoice_number: item?.invoice_number ? <div className='_dateNtime'>
        <span className='_tblText'> {item?.invoice_number} </span>
        {/* <span className='_lgtText'> Invoice Number </span> */}
      </div> : '-',
      sap_invoice_number: item?.sap_invoice_number ? <div className='_dateNtime'>
        <span className='_tblText'> {item?.sap_invoice_number} </span>
        <span className='_lgtText'> {item?.consignor_id?.permission_at_field2?.field_name ? item?.consignor_id?.permission_at_field2?.field_name : ''} </span>
      </div> : '-',
      gst_number: item?.gst_number ? <div className='_dateNtime'>
        <span className='_tblText'> {item?.gst_number} </span>
        <span className='_lgtText'> {item?.consignor_id?.permission_at_field3?.field_name ? item?.consignor_id?.permission_at_field3?.field_name : ''} </span>
      </div> : '-',
      po_number: item?.po_number ? <div className='_dateNtime'>
        <span className='_tblText'> {item?.po_number} </span>
        <span className='_lgtText'> {item?.consignor_id?.permission_at_field4?.field_name ? item?.consignor_id?.permission_at_field4?.field_name : ''} </span>
      </div> : '-',
      mlr_number: item?.mlr_number ? <div className='_dateNtime'>
        <span className='_tblText'> {item?.mlr_number} </span>
        <span className='_lgtText'> {item?.consignor_id?.permission_at_field5?.field_name ? item?.consignor_id?.permission_at_field5?.field_name : ''} </span>
      </div> : '-',
      balance: item?.lr_freight?.balance ? <div className='_tblText' style={{whiteSpace:'nowrap'}}> &#x20B9; {item?.lr_freight?.balance?.toFixed(2)}</div> : '-',
      claim_receivable: item?.lr_freight?.pending_receivable ? <div className='_tblText' style={{whiteSpace:'nowrap'}}> &#x20B9; {item?.lr_freight?.pending_receivable ? +item?.lr_freight?.pending_receivable?.toFixed(2) : 0}</div> : '-',
      claim_payable: item?.lr_freight?.pending_payble ? <div className='_tblText' style={{whiteSpace:'nowrap'}}> &#x20B9; {item?.lr_freight?.pending_payble ? +item?.lr_freight?.pending_payble?.toFixed(2) : 0}</div> : '-',
      updated_by: item?.updated_by ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.updated_by).format('DD MMM YYYY')}</span>
        {/* <span className='_lgtText'>{moment(item?.invoice_date).format('hh:mm A')}</span> */}
      </div> : '-',
    }));
  };

  const updateLrColumns = async (data) => {
    let postData = {
      company_id: StorageService.getCompanyId(),
      lr_columns: data
    }
    try {
      const response = await updateUserLrColumns(postData);
      setColumns(response?.data?.lr_columns);
      setApiData(transformData(response?.data?.lr_list));
      setFilterableColumns(response?.data?.lr_filter_columns);
      setIsMasterFilter(true);
      setTotalPages(Math.ceil(response?.data?.total_record / pageLimit));
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setIsMaterialIndex('');
    setEwayBillLrData({});
  }, [showAddLR])

  const listApiCallOnSaveButtonFunction = async (data) => {
    const stateObj = { ...data, lr_pagination: 1 };
    dispatch(updateInputValue(stateObj))
  }

  const AllClearResetFunction = async () => {
    let obj = {
      branch_id: { label: "All", value: "" },
      consignor_id: { label: "All", value: "" },
      from_location: { label: "All", value: "" },
      to_location: { label: "All", value: "" },
      pod_status: { label: "All", value: 0 },
      eway_bill_status: { label: 'All', value: 0 },
      start_date: "",
      end_date: "",
      lr_status: 0,
      lr_pagination: 1
    }
    setActiveStatus(0);
    dispatch(updateSearchValue(''))
    dispatch(updateInputValue(obj))
  }

  // lr list filters start

  const handleOnChange = async (name, value) => {
    dispatch(updateSearchValue(value ? value : ''))
  };

  const onhandleSelect = async (item, name) => {
    if (item?.startDate && item?.endDate) {
      const stateObj = {
        ...getFiltersValues,
        start_date: moment(item?.startDate),
        end_date: moment(item?.endDate),
      }
      dispatch(updateInputValue(stateObj))
    } else {
      const stateObj = { ...getFiltersValues, [name]: item };
      dispatch(updateInputValue(stateObj))
    }
  };

  // lr list filters end

  // Lr table end

  let firstAddLrModal = {
    isOpen: show,
    closeModal: (e) => setShow(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add LR",
    submitTitle: "Continue",
    nextModal: (e) => setShowAddLR(e),
    showPrefield: showPrefield,
    showingPrefield: (e) => setShowingPrefield(e),
  }

  let firstAddItemModal = {
    isOpen: showAddItem,
    closeModal: (e) => setShowAddItem(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Item",
    submitTitle: "Add Item",
  }

  let firstAddGroupItemModal = {
    isOpen: showAddGroupItem,
    closeModal: (e) => setShowAddGroupItem(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Item Group",
    submitTitle: "Add Item Group",
  }

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);
  }

  const handleStatusChange = async (lrStatus) => {
    // updateGlobalFilters('lr_status', lrStatus)
    if (lrStatus !== activeStatus) { // Check if status actually changes
      setActiveStatus(lrStatus); // Update activeStatus
      // paginationFunction(1); // Reset page to 1 when status changes
      // Debounce the API call to prevent multiple rapid calls
      await new Promise(resolve => setTimeout(resolve, 300)); // Adjust debounce time as needed
    }
  };

  const resetLRTableColumn = async () => {
    try {
      let postData = {
        company_id: StorageService.getCompanyId(),
      }
      const response = await getLRDeaultColumn(postData);
      if (response?.responseCode == 200) {
        setColumns(response?.data?.lr_columns)
      }

    } catch (error) {
      console.error('Error fetching deault LR table column', error);
    } finally {
    }
  }

  const renderStatusFilters = () => (
    <div className='_tabUr_bx'>
      <button className={`tabCst_btn ${activeStatus === 0 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(0); updateGlobalFilters(0) }}> <span >All</span> <span className='_counts'> {dataLrCount?.all} </span> </button>
      <button className={`tabCst_btn ${activeStatus === 1 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(1); updateGlobalFilters(1) }}> <span >Pending</span> <span className='_counts'> {dataLrCount?.pending} </span> </button>
      {/* <button className={`tabCst_btn ${activeStatus === 2 ? '_btnActive' : ''}`} onClick={() => {handleStatusChange(2); updateGlobalFilters(2)}}> <span >In Progress LR</span> <span className='_counts'>5</span> </button> */}
      <button className={`tabCst_btn ${activeStatus === 3 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(3); updateGlobalFilters(3) }}> <span >In Transit</span> <span className='_counts'> {dataLrCount?.in_transit}</span> </button>
      <button className={`tabCst_btn ${activeStatus === 4 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(4); updateGlobalFilters(4) }}> <span >At Party Point </span> <span className='_counts'>{dataLrCount?.at_party_point ? dataLrCount?.at_party_point : 0} </span> </button>
      <button className={`tabCst_btn ${activeStatus === 5 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(5); updateGlobalFilters(5) }}> <span >Delivered </span> <span className='_counts'> {dataLrCount?.delivered} </span> </button>
      <button className={`tabCst_btn ${activeStatus === 6 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(6); updateGlobalFilters(6) }}> <span >Bill Raised</span> <span className='_counts'>{dataLrCount?.bill_raised ? dataLrCount?.bill_raised : 0}</span> </button>
      <button className={`tabCst_btn ${activeStatus === 7 ? '_btnActive' : ''}`} onClick={() => { handleStatusChange(7); updateGlobalFilters(7) }}> <span >Cancelled </span> <span className='_counts'> {dataLrCount?.cancelled} </span> </button>
    </div>
  );

  const callAllApi = () => {
    setIndentId("");
    getLrDataList();
  };

  const handlePermissionCall = async (e) => {
    e.preventDefault();

    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.LR,
      onSuccess: () => setShow(!show),
      setModalConfig, // Pass setter
    });
  };

  let ebillExpProps = {
    isOpen: modalConfig.isOpen,
    closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
    onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
    modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
    headerPart: true,
    floatCrossBtn: true,
    submitTitle: "Send Enquiry",
    messageType: modalConfig.messageType,
    templateId: modalConfig.templateId,
    templateData: modalConfig.templateData
  };

  let permissionModalProps = {
    isOpen: permissionModal,
    closeModal: (e) => setPermissionModal(!permissionModal),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Permission",
    submitTitle: "Close",
    // message: `You don't have access to create a trip`,
    firstSubmitTitle: 'Close',
    firstSubmitHandler: (e) => setPermissionModal(!permissionModal),
    hideSecondButton: false
  }

  return (
    <>
      {hideHeaderSection && <ButtonHeading
        title={"Lorry Receipt"}
        onClick={(e) => handlePermissionCall(e)}
        buttonTitle={lrPermissions?.create === 1 && "Add LR"}
      />}

      <CustomTableNew
        columns={columns}
        data={apiData}
        filterableColumns={filterableColumns}
        isMasterFilter={isMasterFilter}
        currentPage={getSearchValue?.search != '' ? 1 : getFiltersValues?.lr_pagination} // {getFiltersValues?.lr_pagination}
        totalPages={totalPages}
        totalRecords={totalRecords}
        onPageChange={(value) => paginationFunction(value)}
        itemsPerPage={pageLimit}
        setColumns={(data) => updateLrColumns(data)}
        statusApiFilter={renderStatusFilters()}
        initialListFilters={getFiltersValues}
        searchFilterOnChange={handleOnChange}
        dropdownFilterOnChange={onhandleSelect}
        listApiCallOnSaveButtonFunction={listApiCallOnSaveButtonFunction}
        AllClearResetFunction={AllClearResetFunction}
        resetLRTableColumn={() => resetLRTableColumn()}
        loading={loading}
        filterShow={true}
        hidePartyFilter={hideHeaderSection ? true : false}
      />

      {show
        && (
          <AddLrModal {...firstAddLrModal} />
        )
      }

      {showAddItem
        && (
          <AddItemModal {...firstAddItemModal} />
        )
      }

      {showAddGroupItem
        && (
          <AddItemGroupModal {...firstAddGroupItemModal} />
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showAddLR ? 'visible' : 'hidden' }}
      >
        {showAddLR
          && (
            <AddEditLrModal
              isOpen={showAddLR}
              onClose={() => setShowAddLR(false)}
              callGetData={() => { getLrDataList(); getLrTopStatusCount(); }}
            />
          )
        }
      </div>
      <div className={showAddLR ? 'offBack_drop' : ''} style={{ zIndex: lrModalToggleForEway?.ewayModal ? 9999 : 999 }}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas slidedOffCanvas ${lrModalToggleForEway?.ewayModal ? "open" : ""}`}
        tabIndex={-1}
        style={{ visibility: lrModalToggleForEway?.ewayModal ? "visible" : "hidden", zIndex: lrModalToggleForEway?.ewayModal ? 10000 : 1045 }}
      >
        {lrModalToggleForEway?.ewayModal &&
          <FetchEwayBillLrModal
            isOpen={lrModalToggleForEway}
            onClose={() => setLrModalToggleForEway(false)}
            fetchNextModal={(e) => setShowAddLR(e)}
          />}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
      >
        {showLrDetail
          && (
            <LrDetailModal
              isOpen={showLrDetail}
              onClose={(e) => setShowLrDetail(false)}
              nextModal={(e) => handleNextModal(e)}
              callGetData={() => { getLrDataList(); getLrTopStatusCount(); }}
            />
          )
        }
      </div>
      <div className={showLrDetail ? 'offBack_drop' : ''}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: isAddConsignor ? 'visible' : 'hidden' }}
      >
        {isAddConsignor &&
          <AddEditConsignor
            isOpen={isAddConsignor}
            onClose={() => setIsAddConsignor(false)}
            isPreviousModal={(e) => setShow(e)}
            showingPrefield={(e) => setShowingPrefield(true)}
            isTrue={true}
            withoutFirstModalDirectLrOpen={(e) => setShowAddLR(e)}
            hideAddNewOption={StorageService?.getFirmId() ? false : true}
          />
        }
      </div>

      <div className={isAddConsignor ? 'offBack_drop' : ''}></div>

      {/* indent */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showAddIndent ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showAddIndent ? "visible" : "hidden" }}
      >
        {showAddIndent && (
          <AddIndentModal
            isOpen={showAddIndent}
            onClose={(e) => {
              setIndentId("");
              setShowAddIndent(false);
            }}
            callList={callAllApi}
            id={indentId}
          />
        )}
      </div>
      <div className={showAddIndent ? "offBack_drop" : ""}></div>

      {modalConfig.isOpen && <EbillExtentionModal

        {...ebillExpProps}

      />}

      {
        permissionModal
        && (
          <PermissionModal {...permissionModalProps} />
        )
      }

    </>
  )
}

export default Lr